import { api_fetch_throws } from "@/api/client";
import { QueueItem } from "@/api/deduction.tsx";
import { entity } from 'simpler-state';

export type QueueItemType = 'external_message' | 'internal_message' | 'completed_task' | 'expiring_deduction' | 'disputable_deduction';

interface InboxState {
  queueItems: QueueItem[];
  isLoading: boolean;
  error: string | null;
  lastRefresh: Date | null;
  limitPerType: number;
  activeFilters: QueueItemType[];
}

export const inboxState = entity<InboxState>({
  queueItems: [],
  isLoading: false,
  error: null,
  lastRefresh: null,
  limitPerType: 10,
  activeFilters: [],
});

let pollInterval: ReturnType<typeof setInterval> | null = null;

export function setLimitPerType(limit: number) {
  inboxState.set(state => ({ ...state, limitPerType: limit }));
}

export function setActiveFilters(filters: QueueItemType[]) {
  inboxState.set(state => ({ ...state, activeFilters: filters }));
}

export async function fetchQueueItems() {
  try {
    inboxState.set(state => ({ ...state, isLoading: true, error: null }));
    
    const state = inboxState.get();
    const params = new URLSearchParams();
    params.append('limit_per_type', state.limitPerType.toString());
    
    if (state.activeFilters.length > 0) {
      params.append('filter_types', state.activeFilters.join(','));
    }

    const queueItems = await api_fetch_throws<QueueItem[]>(`/inbox/queue?${params.toString()}`);

    inboxState.set(state => ({ 
      ...state,
      queueItems: queueItems || [],
      lastRefresh: new Date(),
      isLoading: false,
      error: null
    }));
  } catch (err) {
    inboxState.set(state => ({ 
      ...state, 
      error: (err as Error).message, 
      isLoading: false 
    }));
  }
}

export function startPolling() {
  if (pollInterval) return;
  
  pollInterval = setInterval(() => {
    fetchQueueItems();
  }, 2 * 60 * 1000); // Poll every 2 minutes
}

export function stopPolling() {
  if (pollInterval) {
    clearInterval(pollInterval);
    pollInterval = null;
  }
}

